import React from 'react';
import { Button } from 'antd';
import { WhatsAppOutlined } from '@ant-design/icons';
import { StaffAvatar } from '../staff/StaffAvatar';
import AppTheme from '../theme/AppTheme';
import uzdLogo from '../../assets/images/uzd_logo_small.jpeg';
import './staff-presence.css';
import { withNotificationActions, createSessionNotificationApi } from '../../utils/actionableNotifications';
import { registerSessionReset } from '../../utils/sessionLifecycle';

const openKeys = new Map();
const colors = ['#5269ad', '#96609c', '#387f7b', '#a56543', '#6c7b3e', '#8d5570', '#466f98'];
export const presenceAvatarColor = id => {
  const hash = Array.from(String(id)).reduce((value, char) => (value * 31 + char.charCodeAt(0)) >>> 0, 0);
  return colors[hash % colors.length];
};
const initials = name => String(name || '').trim().split(/\s+/).filter(Boolean).slice(0, 2).map(word => Array.from(word)[0]).join('').toUpperCase() || '?';

export function dismissPresenceNotices() {
  const notices = [...openKeys.values()];
  openKeys.clear();
  notices.forEach(({ key, api }) => api.destroy(key));
}
registerSessionReset(dismissPresenceNotices);

export function showPresenceNotice(notice, { openPresence, api }) {
  api = withNotificationActions(api || createSessionNotificationApi());
  // Shared service-account transitions have no human user ID. Keep those
  // separate from staff notifications, which merge only while visible.
  const identity = notice.userId == null ? 'service-account' : `user:${notice.userId}`;
  const previous = openKeys.get(identity);
  const key = previous?.key ?? `staff-presence:${notice.key}`;
  const statuses = { ...previous?.statuses, [notice.source]: notice.presence };
  const entry = { key, api, statuses };
  openKeys.set(identity, entry);
  api.open({
    key, duration: 10, className: 'staff-presence-notice',
    icon: <AppTheme><span className="staff-presence-notice-avatar">
      <StaffAvatar size={32} userId={notice.userId} name={notice.userId == null ? "" : notice.name} fallback={initials(notice.name)}
        style={{ backgroundColor: presenceAvatarColor(notice.userId ?? 'service'), color: '#fff' }} />
      <span className="staff-presence-notice-platform" style={{ width: Object.keys(statuses).length > 1 ? 38 : 20 }}>
        {Object.keys(statuses).map(source => <span key={source} aria-label={source}>
          {source === 'SRM' ? <img src={uzdLogo} alt="SRM" /> : <WhatsAppOutlined />}
        </span>)}
      </span>
    </span></AppTheme>,
    message: <AppTheme><div className="staff-presence-notice-title"><strong>{notice.name}</strong>
      <span className="staff-presence-notice-statuses">
        {Object.entries(statuses).map(([source, presence]) => <span key={source}
          style={{ color: presence === 'online' ? '#389e0d' : '#cf1322', fontWeight: 600 }}>
          {source} · {presence === 'online' ? 'Online' : 'Offline'}
        </span>)}
      </span>
    </div></AppTheme>,
    actions: <AppTheme><div className="staff-presence-notice-actions">
      <Button size="small" onClick={() => { dismissPresenceNotices(); openPresence?.(); }}>View staff presence</Button>
    </div></AppTheme>,
    onClose: () => { if (openKeys.get(identity) === entry) openKeys.delete(identity); },
  });
}
